/**
 * Typed wrapper for all Vite environment variables the Studio actually reads.
 * Single source of truth — import `env` instead of accessing import.meta.env directly.
 *
 * Usage:
 *   import { env } from '@/shared/config/env';
 *   const apiUrl = env.API_URL;
 *
 * Trimmed to its one real consumer (src/shared/api/client.ts's axios
 * baseURL) — the dashboard's Auth0 / notification-service / app-env /
 * Studio-embed keys this file used to carry over have zero consumers here
 * (verified by grep across src/); DEV/PROD checks elsewhere in the Studio
 * read `import.meta.env.DEV` / `.PROD` directly rather than through this
 * object. See Plan 2D Task 2 for the trim.
 */
export const env = {
  // API
  API_URL: import.meta.env.VITE_API_URL as string || 'http://localhost:5001/api/v2',

  // Origin (plus any path prefix) under which the backend serves a template's
  // PREVIEW photography, as `<base>/<slug>/<file>`. No default: an unset base
  // means previews render the renderer's grey placeholders rather than 36
  // broken images pointed at a guessed host. See
  // src/entities/store-template/model/previewAssets.ts for the naming rule.
  TEMPLATE_PREVIEW_ASSET_BASE:
    (import.meta.env.VITE_TEMPLATE_PREVIEW_ASSET_BASE as string | undefined) ?? '',
} as const;
